"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiCardContent = void 0;
exports.MuiCardContent = {
    root: {
        padding: 24,
    },
};
